<div id="agentic-chat-interface" style="height: calc(100vh - 84px)"></div>